import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AppBar, Box, Button, Toolbar, Typography } from '@mui/material';
import { OperatorMessagesPanel } from './OperatorMessagesPage';
import { FacilityBoardPanel } from './FacilityBoardPanel';
import { ControlArchivePanel } from './ControlArchivePanel';

export type CommunicationPanelKey = 'messages' | 'facility-board' | 'control-archive';

const TITLES: Record<CommunicationPanelKey, string> = {
  messages: '관제 메시지',
  'facility-board': '시설 게시판',
  'control-archive': '관제 자료실',
};

function parsePanel(raw: string | null): CommunicationPanelKey {
  if (raw === 'facility-board' || raw === 'control-archive' || raw === 'messages') {
    return raw;
  }
  return 'messages';
}

/** 개별 관제 등에서 띄우는 커뮤니케이션 전용 팝업 */
const CommunicationPopupPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const panel = useMemo(
    () => parsePanel(searchParams.get('panel')),
    [searchParams]
  );
  const title = TITLES[panel];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <AppBar position="static" elevation={0}>
        <Toolbar variant="dense" sx={{ gap: 1, minHeight: 44 }}>
          <Typography variant="subtitle1" sx={{ flexGrow: 1, fontWeight: 600 }}>
            {title}
          </Typography>
          <Button color="inherit" size="small" onClick={() => window.close()}>
            닫기
          </Button>
        </Toolbar>
      </AppBar>
      <Box sx={{ flex: 1, overflow: 'auto', p: 2 }}>
        {panel === 'messages' && <OperatorMessagesPanel embedded />}
        {panel === 'facility-board' && <FacilityBoardPanel embedded />}
        {panel === 'control-archive' && <ControlArchivePanel embedded />}
      </Box>
    </Box>
  );
};

export default CommunicationPopupPage;
